<div [ngStyle]="{'width': this.componentWidth}" class="save-panel">
    <button mat-button color="accent" (click)="emitCancel()">CANCEL</button>
    <button mat-button color="primary" (click)="emitSave()">SAVE</button>
</div>
